import { render, staticRenderFns } from "./eventDataDelete.vue?vue&type=template&id=35646b7a&"
import script from "./eventDataDelete.vue?vue&type=script&lang=js&"
export * from "./eventDataDelete.vue?vue&type=script&lang=js&"
import style0 from "./eventDataDelete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports